<template>
  <b-card>
    <div class="custom-container">
      <b-card v-if="cursoAcademia !== null" class="bg-academia">

        <div class="d-flex justify-content-between">
          <vs-button size="large" transparent class="m-0 mb-2" to="/helex/Ayuda/Academia/">
            <i class="fas fa-chevron-left mr-1"></i> Volver a cursos
          </vs-button>
          <vs-button size="large" transparent class="m-0" :to="`/helex/Ayuda/Academia/Notas/${this.$route.params.id}`">
            Ver notas
          </vs-button>
        </div>
        <div class="row">
          <div class="col-12 col-lg-3 d-flex align-items-center">
            <ContenidoHelexium class="rounded w-100" :fileId="cursoAcademia.previewImagenUrl"
              :alt="cursoAcademia.titulo" :BotonDescargarArchivos="false" />
          </div>
          <div class=" col mt-3 mt-md-0 d-flex flex-column" style="gap: 0.5rem">
            <h2 class="font-weight-bold text-capitalize">
              {{ cursoAcademia.titulo }}
            </h2>
            <p class="text-white-50 m-0 h4 custom-descripcion mb-1" style="line-height: 1.5">
              {{ cursoAcademia.descripcion }}
            </p>
            <div class="d-flex align-items-center my-1 flex-wrap">
              <span class="custom-punto d-flex align-items-center font-weight-bold text-success">
                {{ cursoAcademia.categoriaCursoDescripcion }}
              </span>
              <span class="custom-punto d-flex align-items-center text-capitalize">
                Por {{ cursoAcademia.responsable }}
              </span>
              <div v-b-tooltip.hover :title="`${cursoAcademia.privacidad === 1 ? 'Curso público' : 'Curso privado'}`">
                <i :class="`fas fa-${cursoAcademia.privacidad === 1 ? 'earth-americas' : 'lock'}`"></i>
              </div>
            </div>
            <div class="d-flex flex-wrap align-items-center">
              <span class="custom-punto d-flex align-items-center">
                <i class="fas fa-circle-check mr-1"></i> Última actualización:
                <span class="text-primary ml-1"> {{ cursoAcademia.ultimaActualizacion | formatLastUpdateDate }}</span>
              </span>
              <i class="fas fa-clock mr-1"></i>
              <span class="text-white-50 custom-punto d-flex align-items-center">
                {{ cursoAcademia.duracion }}m</span>
              <i class="fas fa-play-circle mr-1"></i>
              <span class="text-white-50">
                {{ listaClases.length }} {{ listaClases.length > 1 ? "clases" : "clase" }}
              </span>
            </div>
          </div>
        </div>
      </b-card>
      <b-card v-if="listaClases.length > 0">
        <div class="row">
          <!-- Visualización -->
          <div class="col-12 col-lg">
            <div class="d-flex flex-column w-100 align-items-center">
              <div class="text-center" v-if="!ContenidoSeleccionado">
                <p class="text-danger">Seleccione uno de los contenidos disponibles en las clases.</p>
                <i class="far fa-arrow-alt-circle-right" style="opacity: 75%; font-size: 2rem" />
              </div>
              <div class="w-100" v-else>
                <div class="text-center" v-if="!isURLValid">
                  <p class="text-danger">Error al cargar el video.</p>
                  <i class="fas fa-video-slash" style="opacity: 75%; font-size: 2rem" />
                </div>
                <div v-else>
                  <div
                    v-if="ContenidoVisualizacion.UrlContenidoCurso && ContenidoVisualizacion.UrlContenidoCurso.length === 11"
                    class="video-container-yt">
                    <YouTubePlayer class="rounded responsive-iframe-yt"
                      :videoId="ContenidoVisualizacion.UrlContenidoCurso" />
                  </div>
                  <ContenidoHelexium class="rounded" style="height: 70vh; width: 100% !important;"
                    :fileId="ContenidoVisualizacion.UrlContenidoCurso" :key="ContenidoVisualizacion.UrlContenidoCurso">
                  </ContenidoHelexium>
                  <div v-if='!ContenidoVisualizacion.Completado' class="d-flex justify-content-end mt-4 mt-1"
                    style="display: block">
                    <vs-button icon @click="ContenidoCompletado(ContenidoVisualizacion.ID)">Marcar como
                      Finalizada <i class="fa-solid fa-circle-check ml-2"></i></vs-button>
                  </div>
                  <div class="mt-4">
                    <div class='d-flex justify-content-between align-items-center flex-wrap w-100' style='gap: 7px;'>
                      <div class="d-flex align-items-center">
                        <i class="fas fa-circle-play mr-2" style="font-size: 2rem" />
                        <div>
                          <small class="text-white-50" style="font-size: 1rem">
                            {{ ContenidoVisualizacion.index + 1 }}/{{ listaContenidos.length }}
                          </small>
                          <h3 class="text-capitalize">{{ ContenidoVisualizacion.Titulo }}</h3>
                        </div>
                      </div>
                      <div>
                        <vs-button-group>
                          <vs-button class="px-4 py-2 mr-2" v-b-tooltip.hover :title="previousVideoTitle"
                            @click="previousVideo"
                            :disabled="disablePrev(ContenidoVisualizacion.index, ClaseSeleccionada.index)" flat icon>
                            <i class="fas fa-step-backward"></i>
                          </vs-button>
                          <vs-button class="px-4 py-2" v-b-tooltip.hover :title="nextVideoTitle" flat icon
                            :disabled="disableNext(ContenidoVisualizacion.index, ClaseSeleccionada.index)"
                            @click="nextVideo">
                            <i class="fas fa-step-forward"></i>
                          </vs-button>
                        </vs-button-group>
                      </div>
                    </div>
                    <div class="col-12 mt-4 w-100">
                      <span class="py-2 text-white-50 font-weight-bold border rounded-top px-2"
                        style="font-size: medium">
                        Descripción
                        <i class="fas fa-info-circle" />
                      </span>
                      <hr class="mt-2" />
                      <p v-if="listaContenidos.length > 0 && this.ContenidoSeleccionado == true" class="h4"
                        style="line-height: 1.5">{{ listaContenidos[this.ContenidoVisualizacion.index].Descripcion }}
                      </p>
                      <h3 v-else> Selecciona un contenido</h3>
                      <!-- {{listaContenidos}} -->
                      <!-- <p v-if="listaContenidos.length > 0" class="h4" style="line-height: 1.5">{{ ContenidoVisualizacion.descripcion }}</p>
                      <h3 v-else> Selecciona un contenido</h3> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Lista de las clases -->
          <div class="col-4 d-none d-lg-block content-list-class p-0">
            <div class="list-clases classListContainer" ref="classListContainer">
              <div v-for="(clase, index) in listaClases" :key="index"
                class="d-flex w-100 align-items-center rounded p-2 card-class">
                <div style='width: 100% !important;'>
                  <div class="row bg-dark m-0 pl-2 py-1" style='border-radius: 5px;'
                    @click="seleccionarClase(clase, index)" :style="{
                      transition: 'box-shadow 0.3s ease',
                      boxShadow: index === ClaseSeleccionada.index ? 'inset 0 0 0 2px #6653d1' : 'none', cursor: 'default'
                    }">
                    <div class="col-3 d-flex justify-content-center align-items-center">
                      <div class="p-2 p-lg-3 rounded-circle" style="box-shadow: 0 -1px 33px -8px rgba(122,215,0,0.69);
                           -webkit-box-shadow: 0 -1px 33px -8px rgba(122,215,0,0.69);
                           -moz-box-shadow: 0 -1px 33px -8px rgba(122,215,0,0.69);
                           background-color: rgba(122,215,0,0.69)">
                        <i class="fa fa-book" style="font-size: 1.5rem"></i>
                      </div>
                    </div>
                    <div class="col-9 my-2 overflow-hidden">
                      <h4 class="font-weight-bold text-capitalize">
                        {{ clase.titulo }}
                      </h4>
                      <p class="text-white-50 m-0 custom-descripcion">
                        {{ clase.descripcion }}
                      </p>
                      <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                        <i class="fas fa-circle-check mr-1"></i>
                        <small class="custom-punto d-flex align-items-center">
                          última actualización
                          <span class="ml-1 text-primary">{{ clase.ultimaAcatualizacion | formatLastUpdateDate }}</span>
                        </small>
                        <i class="fas fa-clock mr-1"></i>
                        <code>{{ clase.duracion }}m</code>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 pr-0">
                    <b-collapse :id="'collapse-' + index" :visible="ClaseSeleccionada.index === index" class="mt-2">
                      <div v-if="LoadingContenidos">
                        <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
                      </div>
                      <div v-else>
                        <div v-if="listaContenidos.length === 0 && listaEvaluaciones.length === 0">
                          No hay contenidos aun cargados
                        </div>
                        <div v-else-if='listaContenidos.length > 0'>
                          <div v-b-tooltip.hover :title="contenido.Completado ? 'Contenido Finalizado' : ''"
                            v-for="(contenido, indexContenido) in listaContenidos" :key="indexContenido"
                            @click="SeleccionarContenido(contenido, indexContenido)" class="col-12 pr-0 mb-2 ">
                            <div class="col-12 position-relative d-flex align-items-center py-2 rounded pointer" :style="{
                              transition: 'box-shadow 0.3s ease',
                              boxShadow: ContenidoVisualizacion.ID === contenido.ID ?
                                ContenidoVisualizacion.Tipo === 'video' ? 'inset 0 0 0 2px #f21343' :
                                  ContenidoVisualizacion.Tipo === 'documento' ? 'inset 0 0 0 2px #085ec5' :
                                    'inset 0 0 0 2px #fe721c' : 'none'
                            }" :class='contenido.Completado ? "bg-primary-transparent" : "bg-dark"'>

                              <div class="row pl-2" @mouseenter="hoveredItem = indexContenido"
                                @mouseleave="hoveredItem = null">
                                <div class="col-2 d-flex justify-content-center align-items-center">

                                  <div v-if="contenido.Completado && hoveredItem === indexContenido"
                                    class="p-2 p-lg-3 rounded-circle d-flex justify-content-center align-items-center bg-primary transition "
                                    style="width: 50px; height: 50px">

                                    <i class=" text-white fa-solid fa-check transition" v-if='contenido.Completado'
                                      style="font-size: 1.5rem"></i>

                                  </div>
                                  <div v-else
                                    class="p-2 p-lg-3 rounded-circle d-flex justify-content-center align-items-center transition"
                                    style="width: 50px; height: 50px"
                                    :class="contenido.Tipo === 'video' ? 'bg-danger' :
                                      contenido.Tipo === 'documento' ? 'bg-primary' : contenido.Tipo === 'imagen' ? 'bg-warning' : 'bg-purple'">


                                    <i class="transition" :class="contenido.Tipo === 'video' ? 'fa fa-play' :
                                      contenido.Tipo === 'documento' ? 'fa fa-file-text' : 'fa-solid fa-image'"
                                      style="font-size: 1.5rem"></i>
                                  </div>

                                </div>
                                <div class="col-10 my-2 overflow-hidden">
                                  <h4 :class="contenido.Completado ? 'text-primary-saturate' : ''"
                                    class="font-weight-bold ">
                                    {{ contenido.Titulo }}
                                  </h4>
                                  <p :class="contenido.Completado ? 'text-primary-saturate' : ''"
                                    class="text-white-50 m-0 custom-descripcion">
                                    {{ contenido.Descripcion.length > 30 ? contenido.Descripcion.substring(0, 30) +
                                      '...' : contenido.Descripcion }}
                                  </p>

                                  <div :class="contenido.Completado ? 'text-primary-saturate' : ''"
                                    class="d-flex align-items-center text-white-50 flex-wrap mt-2 ">
                                    <i class="fas fa-circle-check mr-1"></i>
                                    <small :class="contenido.Completado ? 'text-primary-saturate' : ''"
                                      class="custom-punto d-flex align-items-center">
                                      última actualización
                                      <span class="ml-1 "
                                        :class="contenido.Completado ? 'text-primary-saturate' : 'text-primary'">
                                        {{ contenido.UltimaActualizacion | formatLastUpdateDate }}
                                      </span>
                                    </small>
                                    <i :class="contenido.Completado ? 'text-primary-saturate' : ''"
                                      class="fas fa-clock mr-1"></i>
                                    <code
                                      :class="contenido.Completado ? 'text-primary-saturate' : ''">{{ contenido.Duracion }}m</code>
                                  </div>
                                </div>
                              </div>
                              <!-- <div class="row pl-2">
                                <div class="col-2 d-flex justify-content-center align-items-center">
                                
                                  <div
                                    v-if="contenido.Completado"
                                    class="p-2 p-lg-3 rounded-circle d-flex justify-content-center align-items-center bg-white"
                                    style="width: 50px; height: 50px" >

                                    <i class="text-primary fa-solid fa-check" 
                                      v-if='contenido.Completado'
                                      style="font-size: 2rem"></i>
                                     
                                  </div>
                                  <div
                                  v-else
                                    class="p-2 p-lg-3 rounded-circle d-flex justify-content-center align-items-center"
                                    style="width: 50px; height: 50px" :class="contenido.Tipo === 'video' ? 'bg-danger' :
                                      contenido.Tipo === 'documento' ? 'bg-primary' : contenido.Tipo === 'imagen' ? 'bg-warning' : 'bg-purple'">

                                   
                                    <i :class="contenido.Tipo === 'video' ? 'fa fa-play' :
                                      contenido.Tipo === 'documento' ? 'fa fa-file-text' : 'fa-solid fa-image'"
                                      style="font-size: 1.5rem"></i>
                                  </div>
                                </div>
                                <div class="col-10 my-2 overflow-hidden">
                                  <h4 :class="contenido.Completado ? 'text-white' : '' " class="font-weight-bold ">
                                    {{ contenido.Titulo }}
                                  </h4>
                                  <p :class="contenido.Completado ? 'text-white' : ''" class="text-white-50 m-0 custom-descripcion">
                                    {{ contenido.Descripcion.length > 30 ? contenido.Descripcion.substring(0, 30) + '...' : contenido.Descripcion }}
                                  </p>
                                   
                                  <div :class="contenido.Completado ? 'text-white' : ''" class="d-flex align-items-center text-white-50 flex-wrap mt-2 ">
                                    <i class="fas fa-circle-check mr-1"></i>
                                    <small :class="contenido.Completado ? 'text-white' : ''" class="custom-punto d-flex align-items-center">
                                      última actualización
                                      <span class="ml-1 " :class="contenido.Completado ? 'text-white' : 'text-primary' " >
                                        {{ contenido.UltimaActualizacion | formatLastUpdateDate }}
                                      </span>
                                    </small>
                                    <i :class="contenido.Completado ? 'text-white' : '' " class="fas fa-clock mr-1"></i>
                                    <code :class="contenido.Completado ? 'text-white' : '' ">{{ contenido.Duracion }}m</code>
                                  </div>
                                </div>
                              </div> -->
                              <!-- <div class="row pl-2">
                                <div class="col-2 d-flex justify-content-center align-items-center">
                                  <div
                                    class="p-2 p-lg-3 rounded-circle d-flex justify-content-center align-items-center"
                                    style="width: 50px; height: 50px" :class="contenido.Tipo === 'video' ? 'bg-danger' :
                                      contenido.Tipo === 'documento' ? 'bg-primary' : 'bg-warning'">
                                    <i :class="contenido.Tipo === 'video' ? 'fa fa-play' :
                                      contenido.Tipo === 'documento' ? 'fa fa-file-text' : 'fa-solid fa-image'"
                                      style="font-size: 1.5rem"></i>
                                  </div>
                                </div>
                                <div class="col-10 my-2 overflow-hidden">
                                  <h4 class="font-weight-bold text-capitalize">
                                    {{ contenido.Titulo }}
                                  </h4>
                                  <p class="text-white-50 m-0 custom-descripcion">
                                    {{ contenido.Descripcion.length > 30 ? contenido.Descripcion.substring(0, 30) + '...' : contenido.Descripcion }}
                                  </p>
                                   
                                  <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                                    <i class="fas fa-circle-check mr-1"></i>
                                    <small class="custom-punto d-flex align-items-center">
                                      última actualización
                                      <span class="ml-1 text-primary">
                                        {{ contenido.UltimaActualizacion | formatLastUpdateDate }}
                                      </span>
                                    </small>
                                    <i class="fas fa-clock mr-1"></i>
                                    <code>{{ contenido.Duracion }}m</code>
                                  </div>
                                </div>
                              </div> -->
                            </div>
                          </div>
                        </div>

                        <div v-if='listaEvaluaciones.length > 0'>
                          <h3 class='ml-3 py-2'>Evaluaciones</h3>
                          <div v-b-tooltip.hover :title="evaluacion.nota !== 0 ? 'Evaluación Finalizada' : ''"
                            v-for='(evaluacion, indexEvaluacion) in listaEvaluaciones' :key='indexEvaluacion'
                            @click='RealizarEvaluacion(evaluacion)' class="col-12 pr-0 mb-2">
                            <div @mouseenter="hoveredItemEvaluacion = indexEvaluacion"
                              @mouseleave="hoveredItemEvaluacion = null"
                              class="col-12 d-flex align-items-center py-2 rounded position-relative"
                              :class='evaluacion.nota !== 0 ? "bg-primary-transparent" : "bg-dark"'>
                              <!-- <div class='position-absolute' v-if='evaluacion.nota !== 0'
                                style='top: 50%; right: .5rem;transform: translateY(-50%);'>
                                <i class="fa-solid fa-circle-check" style='font-size: 1.7rem;'></i>
                              </div> -->
                              <div class="row pl-2">
                                <div class="col-2 d-flex justify-content-center align-items-center">
                                  <div v-if="evaluacion.nota !== 0 && hoveredItemEvaluacion === indexEvaluacion"
                                    class="p-2 p-lg-3 rounded-circle d-flex justify-content-center align-items-center bg-primary transition "
                                    style="width: 50px; height: 50px">

                                    <i class=" text-white fa-solid fa-check transition" style="font-size: 1.5rem"></i>

                                  </div>
                                  <div v-else
                                    class="p-2 p-lg-3 rounded-circle d-flex justify-content-center align-items-center bg-success"
                                    style="width: 50px; height: 50px">
                                    <i class="fa-solid fa-file-pen" style='font-size: 1.4rem;'></i>
                                  </div>
                                </div>
                                <div class="col-10 my-2 overflow-hidden">
                                  <h4 :class="evaluacion.nota !== 0 ? 'text-primary-saturate' : ''"
                                    class="font-weight-bold text-capitalize">
                                    {{ evaluacion.Titulo }}
                                  </h4>
                                  <p :class="evaluacion.nota !== 0 ? 'text-primary-saturate' : ''"
                                    class="text-white-50 m-0 custom-descripcion">
                                    {{ evaluacion.Descripcion }}
                                  </p>
                                  <p :class="evaluacion.nota !== 0 ? 'text-primary-saturate' : ''"
                                    class="text-white-50 m-0 custom-descripcion">
                                    N° preguntas: {{ evaluacion.CantidadPreguntas }}
                                  </p>
                                  <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                                    <span :class="evaluacion.nota !== 0 ? 'text-primary-saturate' : ''">Tiempo máximo:
                                    </span>
                                    <code :class="evaluacion.nota !== 0 ? 'text-primary-saturate' : ''"
                                      style='font-size: .8rem;margin-left: 2px;'>{{ evaluacion.TiempoEvaluacionMinutos }} min</code>
                                    <i class="fas fa-clock ml-1"></i>
                                  </div>
                                  <div :class="evaluacion.nota !== 0 ? 'text-primary-saturate' : ''"
                                    class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                                    <span :class="evaluacion.nota !== 0 ? 'text-primary-saturate' : ''"
                                      class="text-primary ml-1">{{ evaluacion.FechaApertura | formatLastUpdateDate
                                      }} - {{ evaluacion.FechaCierre | formatLastUpdateDate }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- <div v-for='(evaluacion, indexEvaluacion) in listaEvaluaciones' :key='indexEvaluacion'
                            @click='RealizarEvaluacion(evaluacion)' class="col-12 pr-0 mb-2">
                            <div class="col-12 d-flex align-items-center py-2 rounded position-relative"
                              :class='evaluacion.nota !== 0 ? "bg-blue" : "bg-dark"'>
                              <div class='position-absolute' v-if='evaluacion.Aplicada'
                                style='top: 50%; right: .5rem;transform: translateY(-50%);'>
                                <i class="fa-solid fa-circle-check" style='font-size: 1.7rem;'></i>
                              </div>
                              <div class="row pl-2">
                                <div class="col-2 d-flex justify-content-center align-items-center">
                                  <div
                                    class="p-2 p-lg-3 rounded-circle d-flex justify-content-center align-items-center bg-success"
                                    style="width: 50px; height: 50px">
                                    <i class="fa-solid fa-file-pen" style='font-size: 1.4rem;'></i>
                                  </div>
                                </div>
                                <div class="col-10 my-2 overflow-hidden">
                                  <h4 class="font-weight-bold text-capitalize">
                                    {{ evaluacion.Titulo }}
                                  </h4>
                                  <p class="text-white-50 m-0 custom-descripcion">
                                    {{ evaluacion.Descripcion }}
                                  </p>
                                  <p class="text-white-50 m-0 custom-descripcion">
                                    N° preguntas: {{ evaluacion.CantidadPreguntas }}
                                  </p>
                                  <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                                    <span>Tiempo máximo: </span>
                                    <code
                                      style='font-size: .8rem;margin-left: 2px;'>{{ evaluacion.TiempoEvaluacionMinutos }} min</code>
                                    <i class="fas fa-clock ml-1"></i>
                                  </div>
                                  <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                                    <span class="text-primary ml-1">{{ evaluacion.FechaApertura | formatLastUpdateDate
                                    }} - {{ evaluacion.FechaCierre | formatLastUpdateDate }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div> -->
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
              </div>
              <!-- <div v-if="EvaluacionesCompletadas > 0 "  class="d-flex w-100 align-items-center rounded p-2 card-class pointer"> -->
              <div v-if="CertificadoFinalizacion"
                class="d-flex w-100 align-items-center rounded p-2 card-class pointer">

                <div @click="$router.push('/helex/CertificadoDeFinalizacion/' + CursoId + '/' + persona.id)"
                  class="row bg-dark m-0 pl-2 py-2" style='border-radius: 5px; width: 100% !important;'>
                  <div class="col-3  px-0 d-flex justify-content-center align-items-center">
                    <div class="rounded-circle d-flex justify-content-center align-items-center" style="width: 4rem; height: 4rem;
                                  box-shadow: 0 -1px 33px -8px var(--cyan);
                                  -webkit-box-shadow: 0 -1px 33px -8px var(--cyan);
                                  -moz-box-shadow: 0 -1px 33px -8px var(--cyan);
                                  background-color: var(--cyan)">
                      <i class="fa fa-graduation-cap" style="font-size: 2rem;  "></i>
                    </div>
                  </div>
                  <div class="col-9 my-2 overflow-hidden">
                    <h4 class="font-weight-bold text-capitalize">
                      Certificado de Finalización
                    </h4>
                    <p class="text-white-50 m-0 custom-descripcion">¡Felicidades por tu Certificado de Finalización!
                    </p>

                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- btn sidebar -->
          <vs-button v-b-toggle.sidebar-variant danger :active="activeSidebar" @click="toggleSidebar"
            :class="{ 'd-none': !activeSidebar }" class="sidebar-toggle-btn d-lg-none">
            <i class="fas fa-chevron-right"></i>
          </vs-button>

          <!-- sidebar list clases -->
          <b-sidebar id="sidebar-variant" bg-variant="dark" text-variant="light" backdrop shadow
            @hidden="toggleSidebar">
            <template v-slot:title>
              <small>Clases del curso...</small>
              <small class="text-primary" style="font-size: 1rem">
                {{ Number(ContenidoVisualizacion.index) + 1 || 0 }}/{{ listaContenidos.length }}
              </small>
            </template>
            <div class="row mx-auto">
              <!-- lista completa de videos -->
              <div>
                <div class="list-clases classListContainer" ref="classListContainer">
                  <div v-for="(clase, index) in listaClases" :key="index"
                    class="d-flex w-100 align-items-center rounded p-2 card-class">
                    <div style='width: 100% !important;'>
                      <div class="row bg-dark m-0 pl-2 py-1" style='border-radius: 5px;'
                        @click="seleccionarClase(clase, index)" :style="{
                          transition: 'box-shadow 0.3s ease',
                          boxShadow: index === ClaseSeleccionada.index ? 'inset 0 0 0 2px #6653d1' : 'none', cursor: 'default'
                        }">
                        <div class="col-3  px-0 d-flex justify-content-center align-items-center">
                          <div class="rounded-circle d-flex justify-content-center align-items-center" style="width: 4rem; height: 4rem;
                                      box-shadow: 0 -1px 33px -8px rgba(122,215,0,0.69);
                                      -webkit-box-shadow: 0 -1px 33px -8px rgba(122,215,0,0.69);
                                      -moz-box-shadow: 0 -1px 33px -8px rgba(122,215,0,0.69);
                                      background-color: rgba(122,215,0,0.69)">
                            <i class="fa fa-book" style="font-size: 2rem;  "></i>
                          </div>
                        </div>
                        <div class="col-9 my-2 overflow-hidden">
                          <h4 class="font-weight-bold text-capitalize">
                            {{ clase.titulo }}
                          </h4>
                          <p class="text-white-50 m-0 custom-descripcion">
                            {{ clase.descripcion.slice(0, 25) }} {{ clase.descripcion.length > 25 ? '...' : '' }}
                          </p>
                          <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                            <i class="fas fa-circle-check mr-1"></i>
                            <small class="custom-punto d-flex align-items-center">
                              última actualización
                              <span class="ml-1 text-primary">{{ clase.ultimaAcatualizacion | formatLastUpdateDate
                              }}</span>
                            </small>
                            <i class="fas fa-clock mr-1"></i>
                            <code>{{ clase.duracion }}m</code>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 pr-0">
                        <b-collapse :id="'collapse-' + index" :visible="ClaseSeleccionada.index === index" class="mt-2">
                          <div v-if="LoadingContenidos">
                            <i class="fas fa-spinner fa-spin fa-2x text-primary"></i>
                          </div>
                          <div v-else>
                            <div v-if="listaContenidos.length === 0 && listaEvaluaciones.length === 0">
                              No hay contenidos aun cargados
                            </div>
                            <div v-else-if='listaContenidos.length > 0'>
                              <div v-b-tooltip.hover :title="contenido.Completado ? 'Contenido Finalizado' : ''"
                                v-for="(contenido, indexContenido) in listaContenidos" :key="indexContenido"
                                @click="SeleccionarContenido(contenido, indexContenido)" class="pr-0 mb-2 pl-0">
                                <div class="col-12 position-relative d-flex align-items-center py-2 rounded pointer"
                                  :style="{
                                    transition: 'box-shadow 0.3s ease',
                                    boxShadow: ContenidoVisualizacion.ID === contenido.ID ?
                                      ContenidoVisualizacion.Tipo === 'video' ? 'inset 0 0 0 2px #f21343' :
                                        ContenidoVisualizacion.Tipo === 'documento' ? 'inset 0 0 0 2px #085ec5' :
                                          'inset 0 0 0 2px #fe721c' : 'none'
                                  }" :class='contenido.Completado ? "bg-primary-transparent" : "bg-dark"'>
                                  <div v-if='contenido.Completado' class='position-absolute'
                                    style='top: 50%; right: .5rem;transform: translateY(-50%);'>
                                    <i class="fa-solid fa-circle-check" style='font-size: 1.7rem;'></i>
                                  </div>
                                  <div class="w-100 d-flex align-items-center pl-2">
                                    <div class="d-flex justify-content-center align-items-center">
                                      <div
                                        class="p-2 p-lg-3 rounded-circle d-flex justify-content-center align-items-center"
                                        style="width: 40px; height: 40px" :class="contenido.Tipo === 'video' ? 'bg-danger' :
                                          contenido.Tipo === 'documento' ? 'bg-primary' : 'bg-warning'">
                                        <i :class="contenido.Tipo === 'video' ? 'fa fa-play' :
                                          contenido.Tipo === 'documento' ? 'fa fa-file-text' : 'fa-solid fa-image'"
                                          style="font-size: 1.5rem"></i>
                                      </div>
                                    </div>
                                    <div class="col-10 my-2 overflow-hidden pr-0">
                                      <h4 class="font-weight-bold text-capitalize">
                                        {{ contenido.Titulo }}
                                      </h4>
                                      <p class="text-white-50 m-0 custom-descripcion">
                                        {{ contenido.Descripcion.slice(0, 30) }} {{ contenido.Descripcion.length > 30 ?
                                          '...' : '' }}
                                      </p>
                                      <div class="text-white-50 mt-1">
                                        <small class="custom-punto d-flex align-items-center">
                                          <i class="fas fa-circle-check mr-1"></i>
                                          última actualización
                                          <span class="ml-1 text-primary">
                                            {{ contenido.UltimaActualizacion | formatLastUpdateDate }}
                                          </span>
                                        </small>
                                        <i class="fas fa-clock mr-1"></i>
                                        <code>{{ contenido.Duracion }}m</code>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div v-if='listaEvaluaciones.length > 0'>
                              <h3 class='py-2'>Evaluaciones</h3>
                              <div v-b-tooltip.hover :title="evaluacion.nota !== 0 ? 'Evaluación Finalizada' : ''"
                                v-for='(evaluacion, indexEvaluacion) in listaEvaluaciones' :key='indexEvaluacion'
                                @click='RealizarEvaluacion(evaluacion)' class="col-12 pr-0 pl-0 mb-2">
                                <div @mouseenter="hoveredItemEvaluacion = indexEvaluacion"
                                  @mouseleave="hoveredItemEvaluacion = null"
                                  class="col-12 d-flex align-items-center py-2 rounded position-relative"
                                  :class='evaluacion.nota !== 0 ? "bg-primary-transparent" : "bg-dark"'>
                                  <div class='position-absolute' v-if='evaluacion.nota !== 0'
                                    style='top: 50%; right: .5rem;transform: translateY(-50%);'>
                                    <i class="fa-solid fa-circle-check" style='font-size: 1.7rem;'></i>
                                  </div>
                                  <div class="d-flex align-content-center pl-2">
                                    <div class="d-flex justify-content-center align-items-center">
                                      <div
                                        class="p-2 p-lg-3 rounded-circle d-flex justify-content-center align-items-center bg-success"
                                        style="width: 40px; height: 40px">
                                        <i class="fa-solid fa-file-pen" style='font-size: 1.4rem;'></i>
                                      </div>
                                    </div>
                                    <div class="col-10 my-2 overflow-hidden">
                                      <h4 class="font-weight-bold text-capitalize">
                                        {{ evaluacion.Titulo }}
                                      </h4>
                                      <p class="text-white-50 m-0 custom-descripcion">
                                        {{ evaluacion.Descripcion.slice(0, 25) }} {{ evaluacion.Descripcion.length > 30
                                          ?
                                          '...' : ''
                                        }}
                                      </p>
                                      <p class="text-white-50 m-0 custom-descripcion">
                                        N° preguntas: {{ evaluacion.CantidadPreguntas }}
                                      </p>
                                      <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                                        <span>Tiempo máximo: </span>
                                        <code style='font-size: .8rem;margin-left: 2px;'>{{ evaluacion.TiempoEvaluacionMinutos }}
                              min</code>
                                        <i class="fas fa-clock ml-1"></i>
                                      </div>
                                      <div class="d-flex align-items-center text-white-50 flex-wrap mt-2">
                                        <span class="text-primary ml-1">{{ evaluacion.FechaApertura |
                                          formatLastUpdateDate
                                        }} - {{ evaluacion.FechaCierre | formatLastUpdateDate }}</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </b-collapse>
                      </div>
                    </div>
                  </div>
                  <div v-if="CertificadoFinalizacion"
                    class="d-flex w-100 align-items-center rounded p-2 card-class pointer">
                    <!-- <p> listaItems --- {{listaItems[0].Nota}} </p> -->
                    <div @click="$router.push('/helex/CertificadoDeFinalizacion/' + CursoId + '/' + persona.id)"
                      class="row bg-dark m-0 pl-2 py-2" style='border-radius: 5px; width: 100% !important;'>
                      <div class="col-3  px-0 d-flex justify-content-center align-items-center">
                        <div class="rounded-circle d-flex justify-content-center align-items-center" style="width: 4rem; height: 4rem;
                                  box-shadow: 0 -1px 33px -8px var(--cyan);
                                  -webkit-box-shadow: 0 -1px 33px -8px var(--cyan);
                                  -moz-box-shadow: 0 -1px 33px -8px var(--cyan);
                                  background-color: var(--cyan)">
                          <i class="fa fa-graduation-cap" style="font-size: 2rem;  "></i>
                        </div>
                      </div>
                      <div class="col-9 my-2 overflow-hidden">
                        <h4 class="font-weight-bold text-capitalize">
                          Certificado de Finalización
                        </h4>
                        <p class="text-white-50 m-0 custom-descripcion">¡Felicidades por tu Certificado de Finalización!
                        </p>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-sidebar>
        </div>
      </b-card>
      <div v-else class="d-flex justify-content-center align-items-center font-italic h3">
        <i class="fas fa-spinner fa-spin mr-1"></i>
        Cargando datos...
      </div>
    </div>
  </b-card>
</template>

<script>
import YouTubePlayer from "../../../../components/helexium/YouTubePlayer.vue";
import moment_timezone from "moment-timezone";
import Swal from 'sweetalert2';
import ContenidoHelexium from "../../../../components/helexium/ContenidoHelexium.vue";

export default {
  name: "AcademiaVideos",
  components: {
    YouTubePlayer,
    ContenidoHelexium
  },
  data() {
    return {
      hoveredItem: null,
      hoveredItemEvaluacion: null,
      CursoId: null,
      activeSidebar: true,
      cursoAcademia: {},
      listaClases: [],
      listaContenidos: [],
      listaEvaluaciones: [],
      isURLValid: false,
      persona: {},
      ContenidoSeleccionado: false,
      ContenidoVisualizacion: {},
      ClaseSeleccionada: {},
      LoadingContenidos: false,
      EvaluacionesCompletadas: [],
      PonderadoActual: null,
      NotaMinimaCurso: null,
      CertificadoFinalizacion: null,
      componentKey: 0
    };
  },
  async mounted() {
    this.$isLoading(true);
    this.persona = JSON.parse(localStorage.getItem("setPersonaAct"));
    this.cursoAcademia = null;
    this.listaClases = [];
    this.CursoId = this.$route.params.id
    await this.getCertificado();


    await this.getListClasesCursoAcademia(this.CursoId);
    // await this.getListClasesCursoAcademia(this.$route.params.id);
    console.log("visualizacion: ", this.ContenidoVisualizacion);
    this.$isLoading(false);
  },
  methods: {
    async getCertificado() {
      try {
        let responseNota = await this.$store.dispatch("hl_get", {
          path: `CursosAcademia/CertificadoDisponible/${this.$route.params.id}/persona/${this.persona.id}`,
        })
        if (responseNota.respuesta) {
          this.CertificadoFinalizacion = responseNota.data;
        }
      } catch (error) {
        console.error("Error: " + error);
      }
    },

    // async infoNota(){
    //   try {
    //     await this.$store.dispatch('hl_get',{
    //       path: `EvaluacionesAcademia/ObtenerIntentosEvaluacion/${this.listaEvaluaciones.Id}/persona/${this.persona.id}`,
    //     }).then(res => {
    //       if (res.respuesta){
    //         this.InfoEvaluacion = res.data.InfoEvaluacion;
    //         // this.intentos = res.data.Intentos;
    //       }
    //     })
    //   }catch (error){
    //     console.log("error:"+error)
    //   }
    // },
    evaluacionesYContenidosCompletados() {

      console.log("Lista de Contenidos:", this.listaContenidos);
      console.log("Lista de Evaluaciones:", this.listaEvaluaciones);

      if (this.listaContenidos.length === 0 || this.listaEvaluaciones.length === 0) {
        console.log("No hay contenidos o evaluaciones suficientes.");
        return false;
      }

      const todosLosContenidosVistos = this.listaContenidos.every(contenido => contenido.Completado === true);
      console.log("Todos los contenidos vistos:", todosLosContenidosVistos);

      const todasLasEvaluacionesRealizadas = this.listaEvaluaciones.every(evaluacion => evaluacion.nota > 0);
      console.log("Todas las evaluaciones realizadas:", todasLasEvaluacionesRealizadas);

      return todosLosContenidosVistos && todasLasEvaluacionesRealizadas;
    },
    toggleSidebar() {
      this.activeSidebar = !this.activeSidebar;
    },
    async getListClasesCursoAcademia(cursoId) {
      try {
        let res = await this.$store.dispatch("hl_get", {
          path: `ClasesCursosAcademia/ObtenerInformacionCurso/${cursoId}/persona/${this.persona.id}`,
        });
        if (res.respuesta) {
          this.cursoAcademia = res.data;
          this.listaClases = res.data.Clases;
          let i = 0;
          while (i < res.data.Clases.length) {
            try {
              await this.seleccionarClase(res.data.Clases[i], i);

              let contenidoNoCompletado = this.listaContenidos.find(contenido => contenido.Completado === false);

              if (this.listaContenidos.length === 0) {
                this.ClaseSeleccionada = { ...this.listaClases[i], index: i };
                break;
              }

              if (this.listaEvaluaciones.length > 0) {
                if (contenidoNoCompletado) {
                  this.ClaseSeleccionada = { ...this.listaClases[i], index: i };
                  await this.SeleccionarContenido(contenidoNoCompletado, i);
                  break;
                }
                let evaluacionRealizada = this.listaEvaluaciones.find(evaluaciones => !evaluaciones.Aplicada);
                if (evaluacionRealizada) {
                  this.ClaseSeleccionada = { ...this.listaClases[i], index: i };
                  Swal.fire({
                    title: 'Evaluación pendiente',
                    text: 'Tienes evaluaciones pendiente por realizar, ¿Deseas realizarla ahora?',
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Sí',
                    cancelButtonText: 'No',
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.RealizarEvaluacion(evaluacionRealizada);
                    }
                  });
                  break;
                }
              } else {
                if (contenidoNoCompletado) {
                  this.ClaseSeleccionada = { ...this.listaClases[i], index: i };
                  await this.SeleccionarContenido(contenidoNoCompletado, i);
                  break;
                }
              }
            } catch (error) {
              console.log("error capturado: ", error);
            }
            i++;
          }
        }
      } catch (error) {
        console.log("error capturado: ", error);
      }
    },
    async SeleccionarContenido(video, index) {
      console.log("Seleccionando contenido: ", video, index);
      this.ContenidoVisualizacion = {};
      this.ContenidoSeleccionado = true;
      this.ContenidoVisualizacion = video;
      this.ContenidoVisualizacion.index = index;
      this.componentKey++;
      console.log("Contenido seleccionado: ", this.ContenidoVisualizacion);
      await this.validateVideoURL(video.UrlContenidoCurso);
    },
    async RealizarEvaluacion(evaluacion) {
      await this.$router.push(`/helex/Ayuda/Academia/InformacionEvaluacion/${evaluacion.ID}`)
    },
    async seleccionarClase(clase, index) {
      this.ContenidoVisualizacion = {};
      this.ContenidoSeleccionado = false;
      this.LoadingContenidos = true
      this.ClaseSeleccionada = clase;
      this.ClaseSeleccionada.index = index;

      await Promise.all([
        this.$store.dispatch('hl_get', {
          path: `ContenidoClasesCursosAcademia/ObtenerContenidos/${clase.id}/persona/${this.persona.id}`
        }),
        this.$store.dispatch('hl_get', {
          path: `EvaluacionesAcademia/ObtenerEvaluacionesClasePersona/${clase.id}/persona/${this.persona.id}`
        })
      ]).then(([contenidoResponse, evaluacionResponse]) => {
        if (contenidoResponse.respuesta) {
          this.listaContenidos = contenidoResponse.data;
          this.LoadingContenidos = false;
        }
        if (evaluacionResponse.respuesta) {
          this.listaEvaluaciones = evaluacionResponse.data;
          console.log("evaluaciones: ", this.listaEvaluaciones);
          this.LoadingContenidos = false;
        }
      }).catch(error => {
        this.LoadingContenidos = false;
        alert('Error al cargar datos:', error);
      });
      const container = this.$refs.classListContainer;

      const element = container.children[index];
      container.scrollTop = element.offsetTop;
      this.LoadingContenidos = false;
    },
    async nextVideo() {
      if (this.ContenidoVisualizacion.index < this.listaContenidos.length - 1) {
        let index = this.ContenidoVisualizacion.index + 1;
        this.ContenidoVisualizacion = this.listaContenidos[this.ContenidoVisualizacion.index + 1];
        this.ContenidoVisualizacion.index = index;
        this.validateVideoURL(this.ContenidoVisualizacion.UrlContenidoCurso);
      }
      else {
        await this.seleccionarClase(this.listaClases[this.ClaseSeleccionada.index + 1], this.ClaseSeleccionada.index + 1);
        await this.SeleccionarContenido(this.listaContenidos[0], 0);
      }
    },
    async previousVideo() {
      if (this.ContenidoVisualizacion.index > 0) {
        let index = this.ContenidoVisualizacion.index - 1;
        this.ContenidoVisualizacion = this.listaContenidos[this.ContenidoVisualizacion.index - 1];
        this.ContenidoVisualizacion.index = index;
        await this.validateVideoURL(this.ContenidoVisualizacion.UrlContenidoCurso);
      } else {
        await this.seleccionarClase(this.listaClases[this.ClaseSeleccionada.index - 1], this.ClaseSeleccionada.index - 1);
        await this.SeleccionarContenido(this.listaContenidos[this.listaContenidos.length - 1], this.listaContenidos.length - 1);
      }
    },
    disableNext(indexContenido, indexClase) {
      return indexContenido === this.listaContenidos.length - 1 && indexClase === this.listaClases.length - 1;
    },
    disablePrev(indexContenido, indexClase) {
      return indexContenido === 0 && indexClase === 0;
    },
    async validateVideoURL(videoURL) {
      try {
        console.log("Video url:   " + videoURL)
        await fetch(videoURL, { method: "HEAD", mode: "no-cors" });
        this.isURLValid = true;
      } catch (error) {
        this.isURLValid = false;
      }
    },
    async ContenidoCompletado(contenidoId) {
      this.listaContenidos.find(cnt => cnt.ID === contenidoId).Completado = true;
      await this.$store.dispatch("hl_post", {
        path: `SeguimientoPersonasCursos/IniciarSeguimientoClaseContenido/${contenidoId}/persona/${this.persona.id}`,
      });
      await this.getCertificado();
      await this.nextVideo();
    },
  },
  computed: {
    nextVideoTitle() {
      if (this.ContenidoVisualizacion.index < this.listaContenidos.length - 1) {
        return this.listaContenidos[this.ContenidoVisualizacion.index + 1].Titulo;
      }
      return "";
    },
    previousVideoTitle() {
      if (this.ContenidoVisualizacion.index > 0) {
        return this.listaContenidos[this.ContenidoVisualizacion.index - 1].Titulo;
      }
      return "";
    },
  },
  filters: {
    formatLastUpdateDate(fechaOriginal) {
      return moment_timezone
        .tz(fechaOriginal, "America/Bogota")
        .format("MMM D, YYYY");
    },
  },
};
</script>

<style scoped>
.transition {
  transition: 0.2s;
}

.video-container {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  /* Proporción 16:9 (9 / 16 = 0.5625 o 56.25%) */
  margin-top: 20px;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.video-container-yt {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  /* Proporción 16:9 (9 / 16 = 0.5625 o 56.25%) */
  margin-top: 20px;
}

.responsive-iframe-yt {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100% !important;
  border: none;
  border-radius: 8px;
  /* box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
}

.iframe2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.content-list-class {
  position: relative;
  max-height: 90vh;
  overflow: hidden;
}

.list-clases {
  max-height: 90vh;
  overflow-y: scroll;
  gap: 1rem;
  padding-bottom: 200px;
  scroll-behavior: smooth;
}

/*------------- .content-list-class se encuentra en la vista _dark.scss y en custom.css-------------------- */

/* .content-list-class::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(16, 36, 68));
  pointer-events: none;
} */

@keyframes show {
  from {
    opacity: 0;
    scale: 25%;
  }

  to {
    opacity: 1;
    scale: 100%;
  }
}

.card-class {
  view-timeline-axis: block;

  animation-timeline: --clase;
  animation-name: show;
  animation-range: entry 25% cover 50%;
  animation-fill-mode: both;
}

.sidebar-toggle-btn {
  height: 10rem;
  position: fixed;
  top: 50%;
  transform: translate(-40%, -50%);
  margin-left: -35px;

  /* left: 0; */
  z-index: 0;
}

.sidebar-toggle-btn:hover {
  transform: translate(-20%, -50%);
}

/* .active {
  background-color: #059668;
} */
.active {
  background-color: rgba(5, 150, 104, 0.8);
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active in <2.1.8 */
  {
  opacity: 0;
}

.circle-badge {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.custom-descripcion {
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}

/* .bg-academia {
  background-image: url(/img/blob-scene-haikei-l.svg);

  background-size: cover;
  background-position: top;
}
.dark .bg-academia {
  background-image: url('/img/blob-scene-haikei.svg');

  background-size: cover;
  background-position: top;
} */

@media screen and (max-width: 768px) {

  .video-container-yt {
    /* position: relative; */
    width: 100%;
    padding-top: 56.25%;
    /* Proporción 16:9 (9 / 16 = 0.5625 o 56.25%) */
    margin-top: 20px;
  }

  .responsive-iframe-yt {
    /* position: absolute; */
    /* top: 0;
  left: 0;
  width: 100%; */
    height: 100% !important;
    /* min-height: 300px; */
    /* border: none;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); */
  }
}
</style>
